import React from 'react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import { formatMoney, isNegativeMoney } from '../lib/money'
import type { CostValues } from '../types'

interface Props {
  scope: CostValues
  currency: string
  locale: string
}

/** Headline figures of the budget (or of the level-1 group it is filtered to), as tiles above the toolbar. */
const BudgetSummary: React.FC<Props> = ({ scope, currency, locale }) => {
  const { t } = useTranslation()
  const tiles: { label: string; value: string }[] = [
    { label: t('CostControl_col_revisedBudget'), value: scope.revisedBudget },
    { label: t('CostControl_col_committed'), value: scope.committed },
    { label: t('CostControl_col_projectedFinalCost'), value: scope.projectedFinalCost },
    { label: t('CostControl_col_variance'), value: scope.variance },
  ]
  return (
    <div className="grid grid-cols-2 gap-3 pb-1 pt-2 md:grid-cols-4">
      {tiles.map(({ label, value }) => (
        <div key={label} className="min-w-0 rounded-lg border p-3">
          <div className={cn('truncate text-xl font-bold leading-none tabular-nums', isNegativeMoney(value) && 'text-destructive')}>
            {formatMoney(value, { locale, currency, whole: true })}
          </div>
          <div className="mt-1.5 truncate text-xs text-muted-foreground">{label}</div>
        </div>
      ))}
    </div>
  )
}
export default BudgetSummary
